import React from "react";
import Navbars from "../Navbar/Navbar";
import ScrollToTop from "../ScrollTop";
import img1 from "../../../Img/11111.png";
import img2 from "../../../Img/11112.png";
import img3 from "../../../Img/11113.png";
import img4 from "../../../Img/11114.png";
import img5 from "../../../Img/11115.png";
import img6 from "../../../Img/11116.png";
import img7 from "../../../Img/11117.png";
import img8 from "../../../Img/11118.png";
import img9 from "../../../Img/11119.png";
import img10 from "../../../Img/11110.png";
import img11 from "../../../Img/111111.png";
import img12 from "../../../Img/111.png";
import Footer from "../Footer/Footer";

const download = [
  {
    text: `💸 Download “WolfWin: Skill Game Online” from the
            Appstore or Playstore`,
    image: img1,
  },
  {
    text: `💸 To sign up, enter email and click on “Send”. You will receive a confirmation email with a code. Enter the code below and click “Verify”. Then Click “Play”.`,
    image: img2,
  },
  {
    text: `💸 On the Home Screen, you will see the skill games available to play. Click “Play” on any game to enter the lobby for that game. In the top right corner, you will see your balance. You will receive a 100 coins bonus when you first sign up, equivalent to $10 USD. (10 coins = $1 USD)`,
    image: img3,
  },
  {
    text: `💸 In the game lobby, you have multiple options to enter. You can enter for free or you can play with coins for a chance to win more coins. You will see the entry fee, bonus amount (amount contributed from bonus wallet to entry fee”, and Prize amount. 
`,
    image: img4,
  },
  {
    text: `💸 Click on the Entry Fee (green box) to enter the tournament. You will be matched to compete with another live player. You will see a time countdown; wait until the time is zero to tournament starts. 
`,
    image: img5,
  },

  {
    text: `💸 Battle begins, give it your best. Win the match by scoring more than your opponent.`,
    image: img6,
  },
  {
    text: `💸 You will see the scoreboard after the game is finished. Click on “Go To Lobby” to go back to home.`,
    image: img7,
  },
  {
    text: `💸 On the “referral” tab, you will see the structure of WolfWin’s referral system. If a player downloads and signs up with WolfWin by entering your referral code, you will receive 50 coins as a bonus. You will receive another 20 coins bonus if that person refers to an additional new player. 
`,
    image: img8,
  },
  {
    text: `💸 On the “Store” tab, you can purchase coins. You will also receive a bonus depending on the package you wish to purchase. For example, in the $9.99 pack shown in the picture below, the user will receive 100 coins in deposit and 5 coins in bonus. The higher the package, the more the bonus!
`,
    image: img9,
  },
  {
    text: `💸 On the “Reward” tab, you can spin the wheel every 24 hours for a chance to win bonus coins. That’s literally free money every day!
`,
    image: img10,
  },
  {
    text: `💸 On the “Account” tab, you will see many account setting options, including Wallet Balance and KYC (needed if you wish to withdraw).
`,
    image: img11,
  },
  {
    text: `💸 Click on “Wallet” in the “Account” tab to see your balance per sub-account, such as Deposit (amount you deposited), Winnings (amount won), and Bonus (amount received in reward and bonus, cannot be withdrawn).
`,
    image: img12,
  },
];

export default function Blog() {
  return (
    <div>
      <Navbars />
      <ScrollToTop />
      <div
        style={{ backgroundColor: "#050810", color: "white" }}
        className="Homemargin"
      >
        <div
          className="d-flex "
          style={{
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "NunitoBlack",
          }}
        >
          <p style={{ color: "#f9c130", fontSize: "30px" }}>Blog</p>
        </div>
        <div
          className="container"
          style={{ lineHeight: 2, fontFamily: "JosefinSans", fontSize: "18px" }}
        >
          <div class="page" title="Page 1">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p>
                    Are you tired of mindless mobile games that offer nothing
                    but fleeting entertainment? Do you crave a platform where
                    your skills are not only challenged but also rewarded? If
                    so, then prepare to embark on an epic journey with WolfWin:
                    Skill Game Online!
                  </p>
                </div>
                <div class="column">
                  <p>
                    Everyone, Imagine this: you're playing your favorite skill
                    games, and you're earning real money. Sounds too good to be
                    true, right? Well, with WolfWin, it's not just a dream, it's
                    a reality.
                  </p>
                </div>
                <div class="column">
                  <p>
                    WolfWin isn't just a game; it's a battleground where
                    strategic minds clash, competitive spirits soar, and the
                    spoils are real. With its diverse selection of skill-based
                    games, exhilarating live tournaments, and lucrative
                    real-world prizes. WolfWin rewards your skills and strategic
                    thinking with real cash that you can actually withdraw and
                    spend on whatever you like. WolfWin offers an unparalleled
                    gaming experience that goes far beyond the typical mobile
                    gaming landscape.
                  </p>
                </div>
                <div class="column">
                  <p>
                    But wait, there's more! To kickstart your WolfWin journey,
                    we're hooking you up with a sweet $10 bonus. That's right,
                    you get a head start on your winning streak before you even
                    begin.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 2">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    🤯 Choose your battleground from our 7 diverse games: 🤯
                  </p>
                  <p>
                    🏆 Chess: Outwit your opponent in a classic battle of wits.
                  </p>
                  <p>
                    🏆 Candy Cream: Master the sweet strategy and crush the
                    competition.
                  </p>
                  <p>
                    🏆 Number Puzzle: Flex your mental muscles and solve your
                    way to victory.
                  </p>
                  <p>
                    🏆 Word Book: Expand your vocabulary and become a word
                    wizard.
                  </p>
                  <p>
                    🏆 Logic Lane: Challenge your mind with intricate puzzles
                    and unlock hidden rewards.
                  </p>
                  <p>
                    🏆 Block Blast: Blast away blocks in a whirlwind of action
                    and score big.
                  </p>
                  <p>
                    🏆 Tic Tac Toe: Rewrite the rules of the classic game and
                    reign supreme.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    🧠 Jump into any game and explore the various tournaments:
                  </p>
                  <p>
                    ⚔️ Free Tournaments: Test your skills and win valuable
                    in-game currency without breaking a sweat.
                  </p>
                  <p>
                    ⚔️ Coin Tournaments: Put your $10 bonus to good use and
                    compete for even bigger prizes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <p
            style={{
              fontFamily: "NunitoBlack",
              fontSize: "20px",
              color: "#f9c130",
            }}
          >
            WolfWin Tutorial Basics:
          </p>

          {download.map((item) => (
            <>
              <p className="mt-4 text-center">{item.text}</p>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {" "}
                <img src={item.image} />
              </div>
            </>
          ))}
          <p>Transform Passion into Profit: Real-World Rewards Await!</p>
          <p>
            WolfWin isn't just about bragging rights; it's about transforming
            your gaming passion into tangible benefits. The satisfaction of
            seeing your skills pay off adds a whole new dimension to the gaming
            experience, making each victory even sweeter.
          </p>
          <p>
            Download WolfWin: Skill Game Online today and claim your free $10
            welcome bonus!
          </p>
          <p
            style={{
              fontFamily: "NunitoBlack",

              color: "#f9c130",
            }}
          >
            AppStore Link:
            <span
              className="px-2"
              style={{
                fontFamily: "NunitoBlack",
                color: "white",
              }}
            >
              <a href="https://apps.apple.com/in/app/wolfwin-skill-game-online/id6467877327">
                https://apps.apple.com/in/app/wolfwin-skill-game-online/id6467877327
              </a>
            </span>
          </p>
          <p
            style={{
              fontFamily: "NunitoBlack",

              color: "#f9c130",
            }}
          >
            PlayStore Link:
            <span
              className="px-2"
              style={{
                fontFamily: "NunitoBlack",
                color: "white",
              }}
            >
              <a href="https://play.google.com/store/apps/details?id=com.wolfwin&pli=1">
                https://play.google.com/store/apps/details?id=com.wolfwin&pli=1
              </a>
            </span>
          </p>
          <p>WolfWin - A Game Worth Your Time!</p>
        </div>
        <Footer />
      </div>
    </div>
  );
}
